import { render } from "./Services.vue?vue&type=template&id=52cb0564&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=52cb0564&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cb0564"]])

export default __exports__